module.exports = __webpack_public_path__ + "img/cart_select.71268a97.png";